import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = request.headers;

    if (request.responseType !== 'text') {
      if (!request.headers.get('Accept')) {
        headers = headers.append('Accept', 'application/json');
      }

      if (!request.headers.get('Content-Type') && !request.headers.get('enctype')) {
        headers = headers.append('Content-Type', 'application/json');
      }
    }

    const newRequest = request.clone({ headers });

    return next.handle(newRequest);
  }
}
